import { gSupportEmail, gUnknownErrorKey, gUseGenericSupportContact } from "../whitelabel/brand";
import { appstr as defaultAppstr } from "./appstr";

export function GetUnknownErrorMessage(
  key = gUnknownErrorKey,
  suffix = "",
  appstrFn = defaultAppstr
) {
  const base = appstrFn(key);
  return gUseGenericSupportContact ? base : `${base.trimEnd()} ${gSupportEmail}${suffix}`;
}
